export const testimonials = [
  {
    name: 'Megan R.',
    role: 'Pediatric OT · Texas, USA',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/f72b2309-bbcd-4f0e-a798-7773d250b90f.jpg',
    quote:
      'The Observation Map changed how I write my notes. I now separate what I actually saw from what I think it means — and my working hypotheses are so much easier to explain to families.',
  },
  {
    name: 'Laura P.',
    role: 'Occupational Therapist · Ontario, Canada',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e7a0b0bc-1d24-4cd8-af12-86e82c46f75d.jpg',
    quote:
      'I used to open five books every time a case felt messy. Now I sit down with the 15-Minute Case Organizer and I know exactly which questions I still need to ask.',
  },
  {
    name: 'Daniel K.',
    role: 'OT Student · Manchester, UK',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6828ef61-b3f2-43fc-836a-85df31159ead.jpg',
    quote:
      'The fictional case challenges are the best practice I’ve had outside placement. They taught me to slow down, list what’s missing, and consider alternative explanations.',
  },
  {
    name: 'Priya S.',
    role: 'Pediatric OT · Melbourne, Australia',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/fd948846-4eab-4447-ace1-444134751e9a.jpg',
    quote:
      'Function → Context → Observable Change → Measurement. That one structure alone made my goals clearer and my progress reviews far more meaningful.',
  },
];
